"use client";

import { useGetAccountQuery } from "@/app/store/account/api";
import { Account } from "@/types/api";
import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from "react";

export interface AuthContextType {
  user: Account | null;
  login: (userData: Account) => void;
  logout: () => void;
}
export const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const { data: account } = useGetAccountQuery();
  const [user, setUser] = useState<Account | null>(null);

  const login = () => {
    // setUser(userData);
  };

  const logout = () => {
    setUser(null);
  };

  useEffect(() => {
    if (!user && account) {
      setUser(account);
    }
  }, [account, user]);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
